// Shared amenity catalogue.
//
// Lives in utils/ so any page that needs to display a room's amenities
// (Rooms, Check In / Out, Reservations, future booking confirmation
// receipts, etc.) can render the same icons + labels without copy-pasting
// the list.  The backend stores amenities as a comma-separated string on
// `rooms.amenities`; `parseAmenities` turns that into an array of keys
// you can hand to AMENITY_BY_KEY[key].

export const AMENITY_OPTIONS = [
  { key: "wifi",         label: "Wi-Fi",        icon: "📶" },
  { key: "ac",           label: "Air Cond.",    icon: "❄️" },
  { key: "ceiling_fan",  label: "Ceiling Fan",  icon: "🌀" },
  { key: "standing_fan", label: "Standing Fan", icon: "🌬️" },
  { key: "tv",           label: "Smart TV",     icon: "📺" },
  { key: "mini_bar",     label: "Mini Bar",     icon: "🥃" },
  { key: "safe",         label: "In-room Safe", icon: "🔒" },
  { key: "hair_dryer",   label: "Hair Dryer",   icon: "💨" },
  { key: "bathtub",      label: "Bathtub",      icon: "🛁" },
  { key: "shower",       label: "Hot Shower",   icon: "🚿" },
  { key: "balcony",      label: "Balcony",      icon: "🌅" },
  { key: "kitchenette",  label: "Kitchenette",  icon: "🍳" },
  { key: "workspace",    label: "Workspace",    icon: "💻" },
  { key: "coffee",       label: "Coffee Maker", icon: "☕" },
  { key: "iron",         label: "Iron",         icon: "👔" },
  { key: "breakfast",    label: "Breakfast",    icon: "🥐" },
  { key: "pet_friendly", label: "Pet Friendly", icon: "🐾" },
  { key: "smoking",      label: "Smoking",      icon: "🚬" },
];

export const AMENITY_BY_KEY = Object.fromEntries(
  AMENITY_OPTIONS.map(a => [a.key, a])
);

// Comma-separated string → array of keys.
export const parseAmenities = (raw) =>
  String(raw || "").split(",").map(s => s.trim()).filter(Boolean);
